import { render, staticRenderFns } from "./SalesListBySeller.vue?vue&type=template&id=4f70cef2"
import script from "./SalesListBySeller.vue?vue&type=script&lang=js"
export * from "./SalesListBySeller.vue?vue&type=script&lang=js"
import style0 from "./SalesListBySeller.vue?vue&type=style&index=0&id=4f70cef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports